import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MasterSearchTransmissionService } from '../services/raintree/Transmission/master-search.service';
import { firstValueFrom, take } from 'rxjs';
import { RitwikTransmissionService } from '../services/raintree/Transmission/ritwik.transmission.service';
import { DpSpReceivingService } from '../services/raintree/Transmission/dp-sp-receiving.service';
import { MatDialog } from '@angular/material/dialog';
import { ReceivingDialogComponent } from './receiving-dialog/receiving-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { DpSpReceivingReportComponent } from '../dp-sp-receiving-report/dp-sp-receiving-report.component';
import { AppConfigService } from '../services/config/app-config.service';
import { RequestMapper } from '../request-mapper';
import { Router } from '@angular/router';
// import { AppConfigService } from '../services/config/app-config.service';
// import { RequestMapper } from '../request-mapper';

@Component({
  selector: 'app-dp-sp-receiving',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    DpSpReceivingReportComponent,
    MatAutocompleteModule,
    DpSpReceivingReportComponent
  ],
  templateUrl: './dp-sp-receiving.component.html',
  styleUrl: './dp-sp-receiving.component.scss'
})
export class DpSpReceivingComponent implements OnInit {
  isCountryIndia: boolean = true;
  isCountryForeign !: boolean;
  isReport !: boolean;
  isDataPresent: boolean = false;
  isDpCountChecked: boolean = false;
  isDpCountNotChecked: boolean = false;
  isSpCountChecked: boolean = false;
  isSpCountNotChecked: boolean = false;
  isShowErrorMessage: boolean = false;
  isReportPermission: boolean = false;
  // isReportPermission: boolean = false;
  workerFamilyCode!: string;
  searchedName = new FormControl('');
  workerCountry = new FormControl('');
  foreignCountries: string[] = [];
  workerDetails: any = [];
  userName: any = '';
  selectedWorkerDetails: any;

  filteredWorkerNames = this.workerDetails;

  workerForm: FormGroup = new FormGroup({
    workerFc: new FormControl('')
  })

  countForm: FormGroup = new FormGroup({
    dpCount: new FormControl('', [Validators.min(1)]),
    spCount: new FormControl('', [Validators.min(1)]),
  })

  constructor(
    public masterSearchS: MasterSearchTransmissionService,
    public ritwikS: RitwikTransmissionService,
    public receivingS: DpSpReceivingService,
    public dialog: MatDialog,
    public toastS: ToastrService,
    private router: Router,
    private appS: AppConfigService,
    // private appS: AppConfigService,
  ) { }

  async ngOnInit(): Promise<void> {
    localStorage.setItem('dp_sp_receive_country', 'ind')
    this.userName = localStorage.getItem('fullName')
    let configData: any = await firstValueFrom(this.masterSearchS.fetchLastRefreshDate().pipe(take(1)))
    configData = configData.data.find((confItem: any) => confItem.configName === 'DSP_RECV_COUNTRIES')
    this.foreignCountries = JSON.parse(configData.date)
    let permission: any = this.appS.getAllPermissions()
    permission = permission.filter((perm: any) => perm.webRoute === RequestMapper.DP_SP_RECEIVING)[0].subview;
    if (permission) {
      console.log(permission[0])
      this.isReportPermission = permission[0].viewName === "dp_sp_receiving_report" ? true : false;
    }
  }

  onClickCountry = (countryVal: string) => {
    if (localStorage.getItem('dp_sp_receive_country') != countryVal) {
      this.resetAllView()
    }

    if (countryVal === 'ind') {
      this.isCountryIndia = true;
      this.isCountryForeign = false;
      this.isReport = false;
      this.isCountryIndia = true;
      this.isCountryForeign = false;
      this.isReport = false;
    } else {
      this.isCountryForeign = true;
      this.isCountryIndia = false;
      this.isReport = false;
      this.isCountryForeign = true;
      this.isCountryIndia = false;
      this.isReport = false;
    }
    localStorage.setItem('dp_sp_receive_country', countryVal)
    console.log(this.isDataPresent)
  }

  onEnterWorkerFamilyCode = (e: any) => {
    let workerFC = e.target.value
    let finalWorkerFc = ''
    if (workerFC.length > 12) {
      finalWorkerFc = workerFC.substring(0, 12)
      console.log(finalWorkerFc)
      this.workerForm.get('workerFc')?.setValue(finalWorkerFc)
    } else if (workerFC.length === 12) {
      this.workerForm.get('workerFc')?.setValue(workerFC)

      this.ritwikS.getWorkerNameFc({
        fc: workerFC,
        name: ''
      }).subscribe({
        next: (response: any) => {
          if (!response.error) {
            this.selectedWorkerDetails = response.data[0]
            console.log(this.selectedWorkerDetails)
            this.isDataPresent = response.error ? false : true
          }
        }, error: (error) => {
          console.log(error)
          throw error;
        }
      })
    }
  }

  onPressWorkername = (e: any) => {
    let entertedWorkername = e.target.value

    if (entertedWorkername.length > 2) {
      this.ritwikS.getWorkerNameFc({
        fc: '',
        name: entertedWorkername
      }).subscribe({
        next: (response) => {
          console.log(response)
          this.workerDetails = response.data
        },
        error: (error) => {
          this.toastS.error(error)
        }
      })
    }
  }

  automatedDropVal(worker: any) {
    console.log(worker)
    let workerfc = worker.dwd_ritwik_code
    this.selectedWorkerDetails = worker
    this.searchedName.setValue(worker.dwd_worker_name);
    this.filteredWorkerNames = [];
    this.isDataPresent = true
  }

  onClickDpChecked = () => {
    this.isDpCountChecked = !this.isDpCountChecked
  }

  onClickDpNotChecked = () => {
    this.isDpCountNotChecked = !this.isDpCountNotChecked
  }

  onClickSpChecked = () => {
    this.isSpCountChecked = !this.isSpCountChecked
  }

  onClickSpNotChecked = () => {
    this.isSpCountNotChecked = !this.isSpCountNotChecked
  }

  resetAllView = () => {
    this.isDataPresent = false
    this.isSpCountChecked = false
    this.isDpCountChecked = false
    this.countForm.get('dpCount')?.setValue('')
    this.countForm.get('spCount')?.setValue('')
    this.workerForm.get('workerFc')?.setValue('')
    this.searchedName.setValue('')
    this.workerCountry.setValue('')
    this.workerDetails = []
  }

  openDialog = (lastIdReceived: number, details: any, workerName: any, receivingName: any): void => {
    const dialogRef = this.dialog.open(ReceivingDialogComponent, {
      data: { message: lastIdReceived, details: details, workerName: workerName, receivingName: receivingName }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('dialog result', result)
    })
  }

  onSubmitCount = async () => {
    console.log(this.countForm.value, this.countForm.valid, this.selectedWorkerDetails)

    //API CALL INSERT
    if (this.countForm.valid) {
      let receivingPayload: any = {}

      receivingPayload = {
        dpReceiveCount: this.countForm.value.dpCount ? this.countForm.value.dpCount : 0,
        dpCountChecked: this.isDpCountChecked ? 1 : 0,
        spReceiveCount: this.countForm.value.spCount ? this.countForm.value.spCount : 0,
        spCountChecked: this.isSpCountChecked ? 1 : 0,
        workerFC: this.selectedWorkerDetails.dwd_ritwik_code || this.selectedWorkerDetails.ritwikCode,
        workerMC: this.selectedWorkerDetails.dwd_ritwik_code || this.selectedWorkerDetails.ritwikCode,
        workerCountry: this.workerCountry.value || 'INDIA',
        workerName: this.selectedWorkerDetails.fullName,
      }

      console.log(receivingPayload)

      if (receivingPayload.dpReceiveCount || receivingPayload.spReceiveCount) {
        this.isShowErrorMessage = false

        this.receivingS.addReceivingDetails(receivingPayload).subscribe({
          next: (response) => {
            this.openDialog(
              response.data,
              receivingPayload,
              this.selectedWorkerDetails.dwd_worker_name || this.selectedWorkerDetails.fullName,
              this.userName
            )
            this.resetAllView()
            if (localStorage.getItem('dp_sp_receive_country') == 'ind') {
              this.isCountryIndia = true
              this.isCountryForeign = false
            } else {
              this.isCountryForeign = true
              this.isCountryIndia = false
            }
          },
          error: (error) => {
            console.log(error)
            this.toastS.error(error)
          }
        })

      } else {
        this.isShowErrorMessage = true
      }
    } else {
      this.toastS.error(`Dp/Sp count should be minimum 1`)
    }
  }

  onClickReport = () => {
    this.isReport = true;
    this.isCountryIndia = false;
    this.isCountryForeign = false;
  }
}
